import _debounce from 'lodash/debounce'
import _reduce from 'lodash/reduce'
import { convertState } from 'utils/state'

import {
  FETCH_STARTED,
  FILTER_CHANGED,
  UPDATE_CLAIMS,
  STATUS_CLAIM
} from 'scenes/Claims/constants'

import request from 'utils/request'

import { CLAIMS_URL } from 'constants'

const SEARCH_QUERY_NAME = 'q'
const STATE_QUERY_NAME = 's'
const CITY_QUERY_NAME = 'c'

/*
 * Transform an object of filters into a URI querystring.
 * Input: { q: 'NEE-8990', type: 1 }
 * Output: '?q=NEE-8990&type=1'
*/
const _parseQuerystring = (filters) => {
  const querystring = _reduce(filters, (qs, value, name) => {
    return !!value ? `${qs}${name}=${value}&` : qs
  }, '?')

  return querystring.slice(0, -1)
}

const fetchingStarted = () => {
  return { type: FETCH_STARTED }
}

const fetchClaims = (dispatch, filters = {}, nextPage = null) => {
  dispatch(fetchingStarted())

  let url

  if(nextPage) {
    url = nextPage
  } else {
    const querystring = _parseQuerystring(filters)
    url = `${CLAIMS_URL}${querystring}`
  }
  request(url)
  .then((res) => {
    dispatch(updateClaims(res.results, filters, res.next, !!nextPage))
  })
  .catch( (e) => {
    dispatch(updateClaims())
  })
}

const _fetchClaims = _debounce(fetchClaims, 500)


const updateClaims = (claims = [], filters = {}, nextPage = null, isNextPage = false) => {
  return {
    type: UPDATE_CLAIMS,
    claims,
    nextPage,
    isNextPage
  }
}


const updteFilterValue = (filter, value) => {
  return {
    type: FILTER_CHANGED,
    filter, value
  }
}


export const filterChanged = (filter, value) => {
  return (dispatch, getState) => {
    // update filter value on redux-state
    dispatch(updteFilterValue(filter, value))

    // fetch claims if filter is not `SEARCH_QUERY_NAME`
    // fetching claims for searching should be done with a debounced function
    // other filters doesn't change so quickly so requests could be performed
    // each time a filter changes.
    if (filter !== SEARCH_QUERY_NAME) {

      if ( filter === STATE_QUERY_NAME ) {
        // if state filter change, clean city filter
        dispatch(updteFilterValue(CITY_QUERY_NAME, null))
      }

      const state = getState()
      const filters = state.claims.get('filters')
      return fetchClaims(dispatch, filters.toJS())
    }
  }
}

export const searchChanged = (value) => {
  return (dispatch, getState) => {
    dispatch(filterChanged(SEARCH_QUERY_NAME, value))

    const state = getState()
    const filters = state.claims.get('filters')
    return _fetchClaims(dispatch, filters.toJS())
  }
}

export const fetchInitialData = () => {
  return (dispatch, getState) => {
    const state = getState()
    const filters = state.claims.get('filters')
    return fetchClaims(dispatch, filters.toJS())
  }
}

export function fetchNextPage() {
  return (dispatch, getState) => {
    const state = convertState(getState(), 'claims')
    const { pagination } = state
    const nextPage = !!pagination.next && pagination.next.indexOf('http') >= 0 ? pagination.next.replace('http', 'https') : pagination.next //live
    // const nextPage = !!pagination.next && pagination.next.indexOf('http') >= 0 ? pagination.next.replace('https', 'http') : pagination.next //dev
    return fetchClaims(dispatch, null, nextPage)
  }
}

export function removeAllFilters() {  
  return (dispatch, getState) => {  
    dispatch(updteFilterValue('t', null))
    dispatch(updteFilterValue('ws', null))
    dispatch(updteFilterValue('ic', null))
    dispatch(updteFilterValue('ib', null))
    dispatch(updteFilterValue('s', null))
    dispatch(updteFilterValue('c', null))
    dispatch(updteFilterValue('ct', null))
    
    const state = getState()
    const filters = state.claims.get('filters')
    return fetchClaims(dispatch, filters.toJS())
  }
}

export function statusChanged(status) {
  return statusList(status)
}

const statusList = (status) => {
  return {
    type: STATUS_CLAIM,
    status
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Claims/actions.js